(function () {
  function alignMegaMenu() {
    var shop = document.querySelector('#proxy-nav .navigation__tier-1 > .navigation__item:first-child');
    var nav = document.querySelector('#main-nav .navigation--main');
    var header = document.querySelector('.section-header');
    if (!shop || !nav || !header) return;
    var left = Math.round(shop.getBoundingClientRect().left - nav.getBoundingClientRect().left);
    header.style.setProperty('--mp-mega-left', Math.max(left, 16) + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alignMegaMenu);
  } else {
    alignMegaMenu();
  }

  window.addEventListener('load', alignMegaMenu);
  window.addEventListener('resize', alignMegaMenu);
  document.addEventListener('on:debounced-resize', alignMegaMenu);
  setTimeout(alignMegaMenu, 300);
})();
